;(function() {
  'use strict'

  PasswordReset.$inject = ["$scope", "$state", "$stateParams", "usersResource"];
  angular.module('app.passwordReset').controller('PasswordReset', PasswordReset)

  // --------------------

  /* @ngInject */
  function PasswordReset($scope, $state, $stateParams, usersResource) {
    $scope.updatePassword = updatePassword
    $scope.login = login

    updatePassword()

    function updatePassword() {
      $scope.state = 'loading'
      usersResource.updatePasswordReset({ id: $stateParams.token }).success(
        function() {
          $scope.redeemed = true
          $scope.state = 'success'
        },
        function(err) {
          $scope.error = err
            ? err.glow.userMessage
            : 'An unknown error has ocurred, please try again.'
          $scope.state = 'error'
        }
      )
    }

    function login() {
      $scope.showLogin().then(function() {
        $state.go('app.public')
      })
    }
  }
})()
